import { createResource } from 'react-resource-router';
import { createHeaders } from '@atlassian/csm-ui-components';
import { getFiltersQuery, serialiseFiltersQueryToSearchParams } from './../common/filters';
import { API_GATEWAY_BASE_URL } from '../utils';

import { isNotExcludedOwner } from './utils';
import type { ConversationResourceResponse, MessageResourceResponse } from './types';
import { fg } from '@atlaskit/platform-feature-flags';

export const conversationsResource = createResource<ConversationResourceResponse>({
	type: 'CONVERSATIONS',
	getKey: (ctx) =>
		`conversations-${serialiseFiltersQueryToSearchParams(getFiltersQuery(ctx.query)).toString()}-${ctx.query.csmAiHubId}`,
	getData: async (ctx) => {
		const headers = createHeaders();
		const queryString = serialiseFiltersQueryToSearchParams(getFiltersQuery(ctx.query));
		const containerBasedApiEnabled = fg('csm_ai_use_container_ari_for_conversations');
		const baseUrl = containerBasedApiEnabled
			? `${API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/${ctx.query.csmAiHubId}/conversations`
			: `${API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/conversations`;

		return fetch(`${baseUrl}?${queryString}`, {
			method: 'GET',
			headers,
		})
			.then((response) => response.json())
			.then((data) => {
				const conversations = data.items.filter(isNotExcludedOwner);
				const error = 'errorMessage' in data ? data : undefined;

				return {
					conversations,
					hasNext: data.hasNext || false,
					// V2 only
					cursor: data.cursor,
					error,
				};
			});
	},
	isBrowserOnly: true,
});

export const messagesResource = createResource<MessageResourceResponse>({
	type: 'CONVERSATION_MESSAGES',
	getKey: ({ match }) => `conversation-messages-${match.params.conversationId}`,
	getData: async ({ match }) => {
		const conversationId = match.params.conversationId;
		if (!conversationId) {
			return {
				messages: [],
				error: {
					errorMessage: 'No conversationId provided',
					errors: ['Missing conversationId'],
					statusCode: 400,
				},
			};
		}

		const headers = createHeaders();

		return fetch(
			`${API_GATEWAY_BASE_URL}/assist/csm/v2/reporting/conversations/${match.params.conversationId}/messages`,
			{
				method: 'GET',
				headers,
			},
		)
			.then((response) => response.json())
			.then((data) => {
				const conversation = data.conversation;
				const messages = data.messages;
				const error = 'errorMessage' in data ? data : undefined;

				return {
					conversation,
					messages,
					error,
				};
			});
	},
	isBrowserOnly: true,
});
